/** Registers the NavigationRegion2D parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNavigationRegion2D } from './parser';
const navigationRegion2DRegistration = {
    typeName: 'NavigationRegion2D',
    parser: parseNavigationRegion2D,
};
nodeRegistry.register(navigationRegion2DRegistration);
//# sourceMappingURL=index.js.map